import { useState } from "react";
// import { GET_BRAND_ITEM_LIST } from "../../Apollo/AdminServices/QueryRequest";
import { GET_BRAND_ITEM_LIST } from "../../Apollo/AdminServices/QueryRequest";
import graphHandler from "../../Apollo/graphHandler";
import { isValidArray } from "../Functions/Filter";

function useGetBrandList(preLoad = false) {
  const [brandList, setBrandList] = useState([]);
  const [loading, setLoading] = useState(preLoad);

  const getBrandList = async (req = {}, sCB = () => {}, eCB = () => {}) => {
    setLoading(true);
    const defaults = {
      active: true,
      is_test_brand: false,
      is_product_sync_completed: true,
      is_shopify_sync_completed: true,
      is_product_approved: true,
    };
    try {
      const { data } = await graphHandler().invoke(
        GET_BRAND_ITEM_LIST,
        { ...defaults, ...req },
        0,
        false,
        true
      );
      if (
        data &&
        data.getAllBrandList &&
        isValidArray(data.getAllBrandList.brands)
      ) {
        // console.log("getBrandList Success", data.getAuthorList);
        setBrandList([]);
        setBrandList(data.getAllBrandList.brands);
        sCB(data.getAllBrandList.brands);
        setLoading(false);
      } else {
        setBrandList([]);
        setLoading(false);
        eCB();
      }
    } catch (error) {
      console.error("getBrandList", error);
      setBrandList([]);
      setLoading(false);
      eCB();
    }
  };

  return {
    brandList,
    loading,
    getBrandList,
  };
}

export default useGetBrandList;
